import { useState, createContext, useContext, useCallback } from 'react'
import { getMoistureEquilibrium } from '../util'
import type { FCWithChildren } from '../types'

export type MoistureEquilibriumCalculate = {
  temp: number
  oilContent: number
  relativeHumidity: number
}

const useMoistureEquilibrium = () => {
  const [calculatingMoistureEquilibrium, setCalculatingMoistureEquilibrium] =
    useState(false)

  const [moistureEquilibrium, setMoistureEquilibrium] = useState<number>()

  const calculateMoistureEquilibrium = useCallback(
    ({ temp, oilContent, relativeHumidity }: MoistureEquilibriumCalculate) => {
      const result = getMoistureEquilibrium({
        oilContent,
        temp,
        relativeHumidity,
      })
      setMoistureEquilibrium(result)
      return result
    },
    [setMoistureEquilibrium],
  )

  return {
    calculateMoistureEquilibrium,
    calculatingMoistureEquilibrium,
    setCalculatingMoistureEquilibrium,
    moistureEquilibrium,
    setMoistureEquilibrium,
  }
}

const defaultContext = {}
const MoistureEquilibriumContext = createContext(
  defaultContext as ReturnType<typeof useMoistureEquilibrium>,
)

export const MoistureEquilibriumProvider: FCWithChildren = ({ children }) => (
  <MoistureEquilibriumContext.Provider value={useMoistureEquilibrium()}>
    {children}
  </MoistureEquilibriumContext.Provider>
)

export const useMoistureEquilibriumContext = () =>
  useContext(MoistureEquilibriumContext)
